import { BusinessOwner } from "@/proto/admin/all_pb";
import { KYCStatusMap, PICTypeMap } from "@/proto/identity/identity/all_pb";
import { TFileUpload } from "./common";
import { EnvironmentMap } from "@/proto/common/ctypes/all_pb";

export enum TransactionStatus {
  // PENDING statuses
  CREATED = "CREATED",
  PENDING = "PENDING",
  AWAITING_APPROVAL = "AWAITING_APPROVAL",

  // ERROR statuses
  LOGIN_ERROR = "LOGIN_ERROR",
  ERROR = "ERROR",
  REJECTED = "REJECTED",
  FAILED = "FAILED",
  INVALID = "INVALID",
  CANCELED = "CANCELED",

  // COMPLETED statuses
  COMPLETED = "COMPLETED",
  SUCCESS = "SUCCESS",
  APPROVED = "APPROVED",
  PROCESSED = "PROCESSED",
}

export enum EDocumentTypeMap {
  DOE = "doe",
  DOA = "doa",
  LIST_OF_DIRECTOR = "director_list",
  LIST_OF_SHAREHOLDER = "shareholder_list",
  NIB_SKDP = "nib_skdp",
  SIUP = "siup",
  NPWP = "npwp",
  SIGNED_MSA = "signed_msa",
  ACRA = "acra",
  BUSINESS_PERMIT = "business_permit",
  TIN = "tin",
  SEC_REGISTRATION = "sec_registration",
  ARTICLES_OF_INCORP = "articles_of_incorporation",
  BENEFICIAL_OWNERSHIP = "beneficial_ownership",
  KTP = "ktp",
  KITAS = "kitas",
  KITAP = "kitap",
  GOV_ID = "govId",
  PASSPORT = "passport",
  DTI = "dti",
  NATIONAL_ID = "nationalId",
  SIGNATURE = "signature",
  // For AS & Billing PIC
  POA_DOC = "poaDoc",
  ID_DOC = "idDoc",
  DIR_ID_DOC = "dirIdDoc",
}

export interface IFileItem {
  fileId?: string;
  fileUrl?: string;
  fileName?: string;
  file?: File;
}

export type TPreviousDocumentData = Record<EDocumentTypeMap, Array<IFileItem>>;

export interface ClientListItem {
  id: string;
  name: string;
  country: string;
  transactions: number;
  kycStatus: KYCStatusMap[keyof KYCStatusMap];
  logo?: string;
  access?: string;
}

export interface ClientListResponse {
  clientList: ClientListItem[];
  total: number;
}

export interface UserListItem {
  name: string;
  created: Date;
  designation: string;
  email: string;
  lastlogin?: Date;
  isactive: boolean;
}

export interface PersonInfo {
  id?: string;
  picIndex?: number;
  roleType?: PICTypeMap[keyof PICTypeMap];
  isDirector?: boolean;
  fullName: string;
  role: string;
  phoneNumber: string;
  phoneNumberCountryCode: string;
  email: string;
  [EDocumentTypeMap.POA_DOC]: IFileItem | TFileUpload[];
  [EDocumentTypeMap.ID_DOC]: IFileItem | TFileUpload[];
  [EDocumentTypeMap.DIR_ID_DOC]: IFileItem | TFileUpload[];
  poaFileId?: string;
  identificationFileId?: string;
  directorIdentificationFileId?: string;
}

export interface ClientInfo {
  name: string;
  role?: string;
  logo?: File;
  logoUrl?: string;
  addressline1: string;
  addressline2?: string;
  city: string;
  province: string;
  postalCode?: string;
  country: string;
  industry?: string;
  description?: string;
  phoneNumber: string;
  phoneNumberCountryCode: string;
  isLive?: boolean;
  taxId?: string;
  authorizedSignatory?: PersonInfo[];
  financePIC?: PersonInfo[];
  businessType?: string;
  noEmployees?: string;
  transactionPerMonth?: string;
  revokeReason?: string;
  businessProfile?: string;
  userType?: string;
  domicileType?: string;
  kycStatus?: KYCStatusMap[keyof KYCStatusMap];
  liveDate?: Date | null;
  companyProfile: string;
  dateOfEstablishment?: string;
  placeOfEstablishment?: string;
  hasPhysicalStore: boolean;
  businessOwner?: BusinessOwner.AsObject;
  subIndustry?: string;
  supportingDocsData?: {
    documentNumber: string;
    documentType: EDocumentTypeMap;
    taxIdNumber: string;
    documents: TPreviousDocumentData;
    isShareholdersDeclared: boolean;
    isDirectorsDeclared: boolean;
    previousDocumentIds: string[];
  };
}

export interface BankAccount {
  accountNumber: string;
  bankName: string;
}

export interface Transaction {
  id: string;
  date?: number;
  from: BankAccount;
  to: BankAccount;
  amount: string;
  currency: string;
  status: TransactionStatus;
}

export interface ClientSecret {
  id?: string;
  environment: EnvironmentMap[keyof EnvironmentMap];
  bank: string;
  clientId: string;
  clientSecret: string;
  apiKey: string;
  publicKey: string;
  publicKeyFilename: string;
  accessKey: string;
  signKey: string;
  notifyKey: string;
  partnerId: string;
  partnerSecret: string;
  merchantID: string;
}

export interface ClientFormData {
  label: string;
  visible: boolean;
  type: EContentType;
  content?: string | IFileItem[];
}

export enum EContentType {
  TEXT = "text",
  FILE = "file",
}
